var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"flex-table"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex-table--row"},[_c('div',{staticClass:"flex-table--cell flex-table--cell-grow-always"},[_c('redactor',{attrs:{"config":{
							formatting: ['p', 'h1', 'h2', 'h3'],
							buttons: ['format', 'bold', 'italic', 'ul'],
							plugins: ['fontcolor'],
							minHeight: '300px'
						},"name":"body"},model:{value:(_vm.body),callback:function ($$v) {_vm.body=$$v},expression:"body"}})],1)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-table--row"},[_c('div',{staticClass:"flex-table--cell flex-table--cell-grow-always"},[_c('h5',{staticClass:"job-information-card--header-title"},[_vm._v("PDF Statement Page")])])])
}]

export { render, staticRenderFns }